
import React, { useEffect, useState, useRef, useCallback } from "react";
import cn from "classnames";
import styles from "./ServiceListing.module.scss";
import Master from "screen/Master";
import Table from "../../components/common/Table";
import NewTableList from "components/common/NewTableList";
// import Search from "../../components/common/Search";
import { getRequest } from "../../services/axiosBaseClient";
import { Link, useHistory } from "react-router-dom";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";



var pageSize = 10;
var pageNumber = 0;
var pagingString = "limit=" + pageSize + "&offset=" + pageNumber;
var tempTigger;

function ServiceRequestView(props) {
  const history = useHistory();
  var tempTigger;

  const [serviceRequestData, setServiceRequestData] = useState([]);
  const [serviceRequestDataCount, setServiceRequestDataCount] = useState();



  useEffect(() => {
    console.log(history, "history")
    tempTigger = !history?.location?.state?.compomentRenderType
      ? "init"
      : history?.location?.state?.compomentRenderType === "amhitted"
        ? "amhitted"
        : history?.location?.state?.compomentRenderType === "view"
          ? "view"
          : "init";

    console.log(tempTigger, "tempTigger")

    // searchSwapStationByFilter();
  }, [
    history?.location?.state?.compomentRenderType ||
    props.history?.location?.state?.compomentRenderType,
  ]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    getRequestDetailList();
  }, []);


  const paginationCountHanlde = (offsett, limit, tigger, tempHeaderFilter) => {
    tempTigger = tigger;
    const testCount = tigger == "amhitted" ? 1 : offsett;
    // pageNumber = offsett;
    pageNumber = offsett;
    pageSize = limit;
    pagingString = "&limit=" + pageSize + "&offset=" + pageNumber;
    getRequestDetailList();
  };

  const getRequestDetailList = useCallback(async (searchString) => {
    await getRequest("requestService/getAllServicesRequest?" + pagingString)
      .then((res) => {
        if (res && res.data && res.data.serviceRequestDetailsDtoList.length >= 1) {
          setServiceRequestDataCount(res.data.count);
          setServiceRequestData(res.data.serviceRequestDetailsDtoList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
        if (err) {
          setServiceRequestData([]);
        }
      });
  }, []);

  const viewServiceList = (id) => {
    history.push(`/ServiceRequest/ViewService/${id}/:view`);
    // window.location.reload();
  };

  const updateServiceList = (id) => {
    history.push(`/ServiceRequest/UpdateService/${id}`);
    // window.location.reload();
  };

  useEffect(() => {
    localStorage.setItem("activeTabCount", "zoneAsset");
  }, [])

  const columns = React.useMemo(() => [
    {
      Header: "Request ID",
      accessor: "referenceId",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.referenceId ? row.row.values.referenceId : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Category of Issues",
      accessor: "category",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.category ? row.row.values.category : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Driver Email",
      accessor: "driverEmail",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.driverEmail ? row.row.values.driverEmail : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Driver Name",
      accessor: "driverName",
      Cell: (row) => {
        return (
          <div>
            {row.row.values.driverName ? row.row.values.driverName : "NA"}
          </div>)
      },
      minWidth: "100px",
    },
    {
      Header: "Asset",
      accessor: "asset",
      minWidth: "100px",
      Cell: (row) => {
        const asset = row?.row.original?.asset;
        if (!asset) return "";
        return asset
          .split("_")
          .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
          .join(" ");
      },
    },
    {
      Header: "Status",
      accessor: "status",
      minWidth: "100px",
      Cell: (row) => {
        return (
          <>
            {row?.row.original?.status === "CREATED" ? (
              <p className={cn(styles.Status1, styles.Status4)}>
                <span>Created</span>
              </p>
            ) : (
              ""
            )}

            {row?.row.original?.status === "ASSIGNED" ? (
              <p className={cn(styles.Status1, styles.Status6)}>
                <span>Assigned</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "INPROGRESS" ? (
              <p className={cn(styles.Status1, styles.Status3)}>
                <span>Inprogress</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "PENDING" ? (
              <p className={cn(styles.Status1, styles.Status1)}>
                <span>Pending</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "BLOCKED" ? (
              <p className={cn(styles.Status1, styles.Status2)}>
                <span>Blocked</span>
              </p>
            ) : (
              ""
            )}
            {row?.row.original?.status === "CLOSED" ? (
              <p className={cn(styles.Status1, styles.Status5)}>
                <span>Closed</span>
              </p>
            ) : (
              ""
            )}
            {/* {row?.row.original?.status === null ? (
              <p className={cn(styles.Status1, styles.Status2)}>
                <span>Created</span>
              </p>
            ) : (
              ""
            )} */}
          </>
        );
      },
    },
    {
      Header: "Action",
      width: "50px",
      accessor: "zoneId",
      disableSortBy: true,
      Cell: (row) => {
        return (
          <>
            <div>
              <img
                src={require("assets/eye.png").default}
                className={cn(styles.Img)}
                onClick={() => viewServiceList(row.row.original.referenceId)}
              ></img>

              <img
                src={require("assets/pencil.png").default}
                className={cn(styles.Img)}
                onClick={() => updateServiceList(row.row.original.referenceId)}
              ></img>
            </div>
          </>
        );
      },
    },
  ]);

  return (
    <>
      <h2 id="ServiceRequest_Heading" className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Service Request"}
      </h2>

      <div id="ServiceRequest_TotalCount_Container" className={cn(styles.block8, styles.block8_layout)}>
        <div id="ServiceRequest_TotalCount_Container1" className={cn(styles.flex91, styles.flex91_layout)}>
          <div id="ServiceRequest_TotalCount_block" className={cn(styles.block8_item)}>
            <div id="ServiceRequest_TotalCount_box" className={cn(styles.block23, styles.block23_layout)}>
              <div className={cn(styles.box10, styles.box10_layout)} />
              <div id="ServiceRequest_TotalCount_box1" className={cn(styles.box11, styles.box11_layout)}>
                <>
                  <img
                  id="ServiceRequest_TotalCount_img"
                    src={require("assets/servicerequest1.png").default}
                    style={{
                      marginLeft: "7px",
                      marginTop: "6px",
                      cursor: "pointer",
                    }}
                  />
                </>
              </div>
            </div>
          </div>
          <div className={cn(styles.block8_spacer)} />
          <div id="ServiceRequest_TotalCount_TextBlock" className={cn(styles.block8_item1)}>
            <div  id="ServiceRequest_TotalCount_TextLayout" className={cn(styles.block21, styles.block21_layout)}>
              <div id="ServiceRequest_TotalCount_Text" className={cn(styles.block22, styles.block22_layout)}>
                <h3 id="ServiceRequest_TotalCount_title" className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                  {"Total Count"}
                </h3>
              </div>

              <div
              id="ServiceRequest_TotalCount_value"
                className={cn(
                  styles.small_text_body1,
                  styles.small_text_body1_layout
                )}
              >
                {serviceRequestDataCount}
              </div>
              <div
                className={cn(
                  styles.small_text_body1,
                  styles.small_text_body1_layout1
                )}
              >
                {""}
              </div>
            </div>
          </div>
        </div>

        <div className={cn(styles.flex7_spacer)} />

        <div className={cn(styles.flex7, styles.flex7_layout)}>
          {/* <div className={cn(styles.flex7_item)}>
                  <Search onSearch={"tracking"} placeholder={"Search"} />
                </div> */}

          {/* <Link to="/ServiceRequest/ServiceListing" style={{ color: "white" }}> */}
          <Link
            to={{
              pathname: "/ServiceRequest/ServiceListing",
              state: {
                compomentRenderType: "amhitted",
              }


            }}
          // to="/ServiceRequest/ServiceListing" style={{ color: "white" }}

          >
            <div id="ServiceRequest_AddService_block" className={cn(styles.flex5_item)} style={{ color: "white" }} >
              <div
              id="ServiceRequest_AddService_layout"
                style={{ cursor: "pointer" }}
                className={cn(
                  styles.graph_filter_block,
                  styles.graph_filter_block_layout,
                  styles.flex6,
                  styles.flex6_layout
                )}
              >
                <div
                id="ServiceRequest_AddService_border"
                  className={cn(
                    styles.graph_filter_text_block,
                    styles.graph_filter_text_block_layout,
                    styles.bgBlew,
                    styles.pd10,
                    styles.borderRadius
                  )}
                >
                  <div>
                    <img
                    id="ServiceRequest_AddService_img"
                      src={require("assets/Vector (5).png").default}
                      className={cn(styles.box2, styles.box2_layout)}
                    />
                  </div>
                  <div
                  id="ServiceRequest_AddService_Title"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Add Service"}
                  </div>
                </div>
                {/* <div className={cn(styles.box16, styles.box16_layout)}></div> */}
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className={cn(styles.block1)}>
        {/* <div className={cn(styles.flex6, styles.flex6_layout)}>
          
        </div> */}
        {/* <div className={cn(styles.header)}>
          <div className={cn(styles.header1)}>{"Tickets "}</div>

          <div className={cn(styles.Subheader)}>
            <div className={cn(styles.header2)}>{"Total Tickets :"}</div>

            <div className={cn(styles.header3)}>
              {serviceRequestDataCount}
            </div>
          </div>
        </div> */}
        {/* 
        <Table
          columns={columns}
          data={serviceRequestData}
        /> */}
        {/* NewTableList  NewTableAndSearchMasterFilter*/}
        <NewTableList
          // pageLimitHandle={pageLimitHandle}
          searchOpts={{
            // onSearch: searchByKey,
            // onSearch: searchBySwapStationID,
            placeholder: "Search by Swapping Station",
            // filter: true,
            // onFilterSearch: getRequestDetailList,
            screentype: "swapping",
          }}
          // headerFilter={props.headerFilter}
          tigger={tempTigger}
          columns={columns}
          data={serviceRequestData}
          paginationDoubleScreen={true}
          swapStationCount={serviceRequestDataCount}
          paginationCountHanlde={paginationCountHanlde}
        />
      </div>
      {/* </div> */}
      {/* </div> */}
    </>
  );
}

export default function ServiceRequest(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1];
  return (
    <>
      <Master
        ServiceRequesturl={Urls}
        opts={props}
        screen={ServiceRequestView}
        showStatus={true}
      />
    </>
  );
}

ServiceRequest.inStorybook = true;
